



















































import TableViewWithPagination from '../components/common/TableViewWithPagination.vue'
import NavbarHeader from '../components/NavbarHeader.vue'
import {motivateAccountingACT as motivateACT} from '../constants/vuexActions'
import {motivateAccountingVars as motivateVars} from '../constants/vuexVariables'
import PincodeInput from 'vue-pincode-input'
import motivateAccountingQueries from '../constants/graphqlAccounting'
export default {
  name: 'WorkersAccountingLayout',
  components: {
    TableViewWithPagination,
    NavbarHeader,
    PincodeInput
  },
  data () {
    return {
      vuexNamespace: 'motivateAccounting',
      pincode: '',
      error: false,
      intervalUpdateMotivate: null
    }
  },
  methods: {
    openModalCloseShift (idWorker) {
      this.$bvModal.show('closeShiftModal' + idWorker)
    },
    closeChange (id) {
      this.$apollo.mutate({
        mutation: motivateAccountingQueries.COOKER_LEAVES_WORK,
        variables: {
          idCooker: id
        }
      }).then((res) => {
        this.dispatch(motivateACT.REQUEST_CURRENT_WORKERS_LIST, null)
      })
    },
    checkPincode () {
      this.$apollo.mutate({
        mutation: motivateAccountingQueries.COOKER_CAME_ON_WORK,
        variables: {
          codeCooker: this.pincode
        }
      }).then((res) => {
        let success = res.data.cookerCameOnWork.boolean
        this.error = !success
        if (success) {
          this.$bvModal.hide('pincodeEnter')
          this.dispatch(motivateACT.REQUEST_CURRENT_WORKERS_LIST, null)
        }
      })
    },
    openChange () {
      this.pincode = ''
      this.error = false
      this.$bvModal.show('pincodeEnter')
    },
    clearPincode () {
      this.pincode = this.pincode.substr(0, this.pincode.length - 1)
    },
    getter (getter) {
      return this.$store.getters[`${this.vuexNamespace}/${getter}`]
    },
    dispatch (action, payload) {
      this.$store.dispatch(`${this.vuexNamespace}/${action}`, payload)
    },
    stateVar (variable) {
      return this.$store.state.motivateAccounting[variable]
    },
    commit (query, payload) {
      this.$store.commit(`${this.vuexNamespace}/${query}`, payload)
    },
    enterPincode (digit) {
      this.pincode = this.pincode.toString() + digit
    }
  },
  created () {
    this.dispatch(motivateACT.REQUEST_CURRENT_WORKERS_LIST, null)
  },
  computed: {
    listWorkers () {
      return this.stateVar(motivateVars.listWorkersOnWork)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/WorkersAccountingLayout.vue